import { render, staticRenderFns } from "./DeliveryTime.vue?vue&type=template&id=6f21c718&scoped=true&"
import script from "./DeliveryTime.vue?vue&type=script&lang=js&"
export * from "./DeliveryTime.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryTime.vue?vue&type=style&index=0&id=6f21c718&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f21c718",
  null
  
)

export default component.exports